import { Component, Event, EventEmitter, h, Host, State, Prop } from "@stencil/core";
import { isEmpty } from '../utils/is-empty.js';

@Component({
  tag: 'lk-feedback-form'
})
export class FeedbackForm {

  @Prop({ mutable: true }) resetValue = '';

  @Event() formSubmit: EventEmitter;
  @Event() formCancel: EventEmitter;

  @Prop({ mutable: true }) isloaded: boolean = false;
  @Prop({ reflect: true }) maxLength: number = 1000;
  @Prop() isPositiveFeedback: boolean = true;
  @Prop() descriptiveText: string = 'Så bra, Kan du fortelle oss hva du lette etter?'
  @State() currentLength: number = 0;
  @State() maxedLength: boolean = false;

  textareaInput: HTMLTextAreaElement;
  textareaId: string = this.isPositiveFeedback ? 'description-yes' : 'description-no';

  componentWillUpdate() {
    this.currentLength = this.textareaInput.value.length;
  }

  getDescription(event: Event) {
    event.preventDefault();
    this.formSubmit.emit(this.textareaInput.value.trim());
  }

  handleCancel(event: Event) {
    event.preventDefault();
    this.textareaInput.value = "";
    this.currentLength = 0;
    this.formCancel.emit();
  }

  textareaInputHandler() {
    this.currentLength = this.textareaInput.value.length;

    if (!isEmpty(this.maxLength)) {
      if (!this.maxedLength) {
        if (this.currentLength >= this.maxLength) {
          this.maxedLength = true;
        }
      } else {
        if (this.currentLength < this.maxLength) {
          this.maxedLength = false;
        }
      }
    }
  }

  componentDidLoad() {
    this.isloaded = true;
  }

  render() {
    let message = null;
    let ariaLive = this.maxedLength
      ? 'assertive'
      : 'off';

    if (!this.maxedLength) {
      message = <p class="input-block__message" aria-live={ariaLive} style={{ color: '#233264' }}>{`${this.currentLength} / ${this.maxLength} tegn.`}</p>;
    } else {
      message = <p class="input-block__warning-message" aria-live={ariaLive} style={{ display: 'block', color: '#a4310e' }}>{`Du har nådd maks antall tegn på ${this.maxLength}.`}</p>
    }

    return (
      <Host>
        <form action="" method="POST" onSubmit={event => { this.getDescription(event) }} >
          <label htmlFor={this.textareaId} class='visually-hidden'>{this.descriptiveText}</label>
          <div id={`${this.textareaId}-wordcount`} class="textarea-wrapper input-block">
            <textarea
              id={this.textareaId}
              aria-describedby={`${this.textareaId}-wordcount`}
              value={this.resetValue}
              ref={el => this.textareaInput = el}
              onInput={() => { this.textareaInputHandler() }}
              name="description"
              maxlength={this.maxLength}
            ></textarea>
            {message}
          </div>
          <div class="padding-y--tiny">
            <button type="submit" class="button button--normal">
              <span class="button__text  padding-x--tiny">Send inn</span>
            </button>
            <button type="button" class="button button--tertiary margin-left--large" onClick={event => { this.handleCancel(event) }}>
              <span class="button__text">Avbryt</span>
            </button>
          </div>
        </form>

        <p class="margin-top--base">
          Takk! Vi bruker denne informasjonen til å lage bedre innhold og tjenester, men vi svarer ikke på disse tilbakemeldingene. Ønsker du svar anbefaler vi at du logger inn og bruker<a href="https://www.altinn.no/Pages/ExternalAuthentication/Redirect.aspx?returnUrl=https://dialog.lillestrom.kommune.no/Form/GeneralInquiry"> tilbakemeldingsskjemaet vårt</a>.
        </p>
      </Host>
    );
  }
}
